export default "__VITE_ASSET__4hpzCoq1__"